import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef, productTeamRouteRef } from './routes';
import {
  productTeamsApiRef,
  MockProductTeamsApi,
  ProductTeamsBackendClient,
} from './api';

export const productTeamsPlugin = createPlugin({
  id: 'product-teams',
  routes: {
    root: rootRouteRef,
    team: productTeamRouteRef,
  },
  apis: [
    createApiFactory({
      api: productTeamsApiRef,
      deps: {
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      // productTeams.useMockApi is only ever true via local-dev-server-only.yaml
      // (loaded by `yarn start`) — never in the docker-compose/production build.
      factory: ({ configApi, discoveryApi, fetchApi }) =>
        configApi.getOptionalBoolean('productTeams.useMockApi')
          ? new MockProductTeamsApi()
          : new ProductTeamsBackendClient(discoveryApi, fetchApi),
    }),
  ],
});

export const ProductTeamsPage = productTeamsPlugin.provide(
  createRoutableExtension({
    name: 'ProductTeamsPage',
    component: () =>
      import('./components/ProductTeamsListPage').then(
        m => m.ProductTeamsListPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const ProductTeamPage = productTeamsPlugin.provide(
  createRoutableExtension({
    name: 'ProductTeamPage',
    component: () =>
      import('./components/ProductTeamPage').then(m => m.ProductTeamPage),
    mountPoint: productTeamRouteRef,
  }),
);
